import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { Button, Calendar, Separator } from '@/components/ui';
import { DateRange } from 'react-day-picker';
import { IPeriod } from '@/interfaces';
import { CircleX } from 'lucide-react';
import { useState } from 'react';
import dayjs from 'dayjs';

interface IState {
  value?: IPeriod;
  open: boolean;
}

type TProps = {
  onChange: (value?: IPeriod) => void;
  onReset?: () => void;
  disabled?: boolean;
  value?: IPeriod;
  text: string;
};

const ButtonFilterPeriod = ({ text, value, disabled, onChange, onReset }: TProps) => {

  const [state, setState] = useState<IState>({ open: false, value });

  const hasValue = state.value?.from || state.value?.to;

  const handleOnClickButton = () => {
    setState(l => ({ ...l, open: !l.open }));
  };

  const handleOnClickButtonApply = () => {
    setState(l => ({ ...l, open: false }));
    onChange(state.value);
  };

  const handleOnClickButtonEraze = () => {
    setState(l => ({ ...l, open: false, value: undefined }));
    onChange();
  };

  const handleOnSelectDate = (range?: DateRange) => {
    setState(l => ({ ...l, value: range }));
  };

  const handleOnClickBtnReset = () => {
    setState(l => ({ ...l, open: false, value: undefined }));
    onChange();
    onReset?.();
  };

  return (
    <div className='flex items-center my-auto'>
      <Popover open={state.open}>
        <PopoverTrigger asChild>
          <Button
            className={`space-x-1 border border-dashed text-xs items-center ${hasValue && 'border-r-0 rounded-r-none'}`}
            variant={hasValue ? 'secondary' : 'ghost'}
            onClick={handleOnClickButton}
            disabled={disabled}
            size={'sm'}>
            <span>
              {text}
            </span>
            {
              (state.value?.from || state.value?.to) &&
              <span className='text-purple-600 font-semibold'>
                {
                  [
                    state.value?.from ? ` : ${dayjs(state.value.from).format('DD/MM/YYYY')}` : null,
                    state.value?.to ? `${dayjs(state.value.to).format('DD/MM/YYYY')}` : null
                  ]
                    .filter(l => l)
                    .join(' - ')
                }
              </span>
            }
          </Button>
        </PopoverTrigger>
        <PopoverContent className='w-auto p-0' align='start'>
          <div className='flex flex-col space-y-2'>
            <Calendar
              autoFocus
              mode='range'
              defaultMonth={state.value?.from}
              selected={{
                from: state.value?.from,
                to: state.value?.to
              }}
              onSelect={handleOnSelectDate}
              numberOfMonths={2} />
            <Separator />
            <div className='flex justify-between px-2 pb-2'>
              <Button
                className='h-8 text-xs'
                onClick={handleOnClickButtonEraze}
                variant={'secondary'}
                size={'sm'}>
                Effacer
              </Button>
              <Button
                className='h-8 text-xs'
                onClick={handleOnClickButtonApply}
                variant={'default'}
                size={'sm'}>
                Appliquer
              </Button>
            </div>
          </div>
        </PopoverContent>
      </Popover>
      {
        hasValue &&
        <Button
          className='space-x-1 border border-dashed border-l-0 rounded-l-none text-xs'
          variant={hasValue ? 'secondary' : 'ghost'}
          title='Supprimer le filtre'
          onClick={handleOnClickBtnReset}
          disabled={disabled}
          size={'sm'}>
          <CircleX size={16} />
        </Button>
      }
    </div>
  );

};

export default ButtonFilterPeriod;
